const EMPTY_LABEL_CONTENT = () => '';

export const emptyGeomLabel = (field: string): [string, Record<string, any>] => [
	field,
	{ content: EMPTY_LABEL_CONTENT },
];
